// src/pages/FavoritesPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AnimalMap from '../components/AnimalMap';
import './FavoritesPage.css';

// Define the base API URL using an environment variable.
const API_URL = process.env.REACT_APP_API_URL;

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [intersectionGeoJSON, setIntersectionGeoJSON] = useState(null);
  const [loadingIntersection, setLoadingIntersection] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  // Function to fetch favorites
  const fetchFavorites = useCallback(() => {
    fetch(`${API_URL}/favorites`, {
      headers: { token }
    })
      .then(response => response.json())
      .then(data => setFavorites(data))
      .catch(err => console.error(err));
  }, [token]);

  // Function to fetch intersection GeoJSON
  const fetchIntersection = useCallback(() => {
    fetch(`${API_URL}/favorites/intersection`, {
      headers: { token }
    })
      .then(response => response.json())
      .then(data => {
         setIntersectionGeoJSON(data);
         setLoadingIntersection(false);
      })
      .catch(err => {
         console.error(err);
         setLoadingIntersection(false);
      });
  }, [token]);

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    fetchFavorites();
    fetchIntersection();
  }, [navigate, token, fetchFavorites, fetchIntersection]);

  const handleRemove = (animalId) => {
    fetch(`${API_URL}/favorites/${animalId}`, {
      method: 'DELETE',
      headers: { token }
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          alert(data.error);
        } else {
          // Refresh favorites and intersection after removal
          fetchFavorites();
          fetchIntersection();
        }
      })
      .catch(err => console.error(err));
  };

  return (
    <div className="favorites-page">
      <h1>Your Favorites</h1>
      <div className="animal-grid">
        {favorites.map(fav => (
          <div key={fav.id} className="animal-item">
            <div onClick={() => navigate(`/animal/${fav.id}`)} style={{ cursor: 'pointer' }}>
              <img src={`${API_URL}${fav.image_path}`} alt={fav.name} />
              <p>{fav.name}</p>
            </div>
            <button className="remove-btn" onClick={() => handleRemove(fav.id)}>
              Remove from Favorites
            </button>
          </div>
        ))}
      </div>
      <h2>Favorites Intersection Map</h2>
      <div className="map-wrapper">
        {loadingIntersection ? (
          <p>Loading intersection...</p>
        ) : intersectionGeoJSON ? (
          <AnimalMap geojson={intersectionGeoJSON} />
        ) : (
          <p>No overlapping area among your favorites.</p>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
